// Register page translations
export const registerTranslations = {
  en: {
    title: "Register",
    subtitle: "Create your Qualitati account",
    auth: {
      actions: {
        register: "Register",
        signIn: "Sign In",
        alreadyHaveAccount: "Already have an account?",
        resendVerification: "Resend Verification Email",
        resending: "Sending..."
      },
      fields: {
        username: "Username",
        email: "Email Address",
        password: "Password",
        confirmPassword: "Confirm Password",
        inviteCode: "Invite Code",
        inviteCodeHelp: "Enter the invite code provided by your organization."
      },
      messages: {
        passwordMismatch: "Passwords do not match",
        checkEmail: "Please check your email to verify your account.",
        checkSpam: "Don't forget to check your spam folder if you don't see the email.",
        verificationNote: "Note: Email verification is required to activate your account.",
        registrationSuccess: "Registration successful! Please check your email to verify your account.",
        registrationFailed: "Registration failed. Please try again.",
        emailSent: "Verification email has been sent to your email address.",
        redirecting: "Redirecting to login page in 5 seconds...",
        emailRequired: "Email is required",
        emailInvalid: "Invalid email format",
        passwordRequired: "Password is required",
        usernameRequired: "Username is required",
        didNotReceiveEmail: "Didn't receive the email?",
        resendFailed: "Failed to resend verification email. Please try again later."
      },
      validation: {
        emailRequired: "Email is required",
        emailInvalid: "Please enter a valid email address",
        passwordRequired: "Password is required",
        passwordTooShort: "Password must be at least 6 characters",
        passwordWeak: "Password does not meet the security requirements",
        usernameRequired: "Username is required",
        usernameTooShort: "Username must be at least 3 characters",
        confirmPasswordRequired: "Please confirm your password",
        inviteCodeRequired: "Invite code is required"
      },
      passwordPolicy: {
        title: "Password requirements",
        rules: {
          length: "At least 8 characters",
          uppercase: "At least one uppercase letter (A–Z)",
          lowercase: "At least one lowercase letter (a–z)",
          number: "At least one number (0–9)",
          special: "At least one special character (!@#$…)"
        },
        strength: {
          weak: "Weak",
          fair: "Fair",
          good: "Good",
          strong: "Strong"
        }
      },
      terms: {
        label: "I have read and agree to the",
        link: "Terms of Service & Privacy Policy",
        required: "You must accept the terms and conditions to register"
      }
    }
  },
  zh: {
    title: "注册",
    subtitle: "创建您的Qualitati账户",
    auth: {
      actions: {
        register: "注册",
        signIn: "登录",
        alreadyHaveAccount: "已有账户？",
        resendVerification: "重新发送验证邮件",
        resending: "发送中..."
      },
      fields: {
        username: "用户名",
        email: "邮箱地址",
        password: "密码",
        confirmPassword: "确认密码",
        inviteCode: "邀请码",
        inviteCodeHelp: "请输入您所在机构提供的邀请码。"
      },
      messages: {
        passwordMismatch: "密码不匹配",
        checkEmail: "请检查您的邮箱以验证您的账户。",
        checkSpam: "如果没有看到邮件，请记得检查垃圾邮件文件夹。",
        verificationNote: "注意：需要进行邮箱验证以激活您的账户。",
        registrationSuccess: "注册成功！请检查您的邮箱以验证您的账户。",
        registrationFailed: "注册失败。请重试。",
        emailSent: "验证邮件已发送到您的邮箱。",
        redirecting: "5秒后将跳转到登录页面...",
        emailRequired: "邮箱为必填项",
        emailInvalid: "邮箱格式无效",
        passwordRequired: "密码为必填项",
        usernameRequired: "用户名为必填项",
        didNotReceiveEmail: "没有收到邮件？",
        resendFailed: "重新发送验证邮件失败。请稍后重试。"
      },
      validation: {
        emailRequired: "邮箱为必填项",
        emailInvalid: "请输入有效的邮箱地址",
        passwordRequired: "密码为必填项",
        passwordTooShort: "密码至少需要6个字符",
        passwordWeak: "密码不符合安全要求",
        usernameRequired: "用户名为必填项",
        usernameTooShort: "用户名至少需要3个字符",
        confirmPasswordRequired: "请确认您的密码",
        inviteCodeRequired: "邀请码为必填项"
      },
      passwordPolicy: {
        title: "密码要求",
        rules: {
          length: "至少 8 个字符",
          uppercase: "至少一个大写字母 (A–Z)",
          lowercase: "至少一个小写字母 (a–z)",
          number: "至少一个数字 (0–9)",
          special: "至少一个特殊字符 (!@#$…)"
        },
        strength: {
          weak: "弱",
          fair: "一般",
          good: "良好",
          strong: "强"
        }
      },
      terms: {
        label: "我已阅读并同意",
        link: "服务条款和隐私政策",
        required: "您必须接受条款和条件才能注册"
      }
    }
  },
  fr: {
    title: "Inscription",
    subtitle: "Créez votre compte Qualitati",
    auth: {
      actions: {
        register: "S'inscrire",
        signIn: "Se connecter",
        alreadyHaveAccount: "Vous avez déjà un compte ?",
        resendVerification: "Renvoyer l'E-mail de Vérification",
        resending: "Envoi en cours..."
      },
      fields: {
        username: "Nom d'utilisateur",
        email: "Adresse e-mail",
        password: "Mot de passe",
        confirmPassword: "Confirmer le mot de passe",
        inviteCode: "Code d'invitation",
        inviteCodeHelp: "Saisissez le code d'invitation fourni par votre organisation."
      },
      messages: {
        passwordMismatch: "Les mots de passe ne correspondent pas",
        checkEmail: "Veuillez vérifier votre e-mail pour vérifier votre compte.",
        checkSpam: "N'oubliez pas de vérifier votre dossier spam si vous ne voyez pas l'e-mail.",
        verificationNote: "Note : La vérification par e-mail est requise pour activer votre compte.",
        registrationSuccess: "Inscription réussie ! Veuillez vérifier votre e-mail pour vérifier votre compte.",
        registrationFailed: "Échec de l'inscription. Veuillez réessayer.",
        emailSent: "L'e-mail de vérification a été envoyé à votre adresse e-mail.",
        redirecting: "Redirection vers la page de connexion dans 5 secondes...",
        emailRequired: "L'e-mail est requis",
        emailInvalid: "Format d'e-mail invalide",
        passwordRequired: "Le mot de passe est requis",
        usernameRequired: "Le nom d'utilisateur est requis",
        didNotReceiveEmail: "Vous n'avez pas reçu l'e-mail ?",
        resendFailed: "Échec du renvoi de l'e-mail de vérification. Veuillez réessayer plus tard."
      },
      validation: {
        emailRequired: "L'e-mail est requis",
        emailInvalid: "Veuillez entrer une adresse e-mail valide",
        passwordRequired: "Le mot de passe est requis",
        passwordTooShort: "Le mot de passe doit contenir au moins 6 caractères",
        passwordWeak: "Le mot de passe ne respecte pas les exigences de sécurité",
        usernameRequired: "Le nom d'utilisateur est requis",
        usernameTooShort: "Le nom d'utilisateur doit contenir au moins 3 caractères",
        confirmPasswordRequired: "Veuillez confirmer votre mot de passe",
        inviteCodeRequired: "Le code d'invitation est requis"
      },
      passwordPolicy: {
        title: "Exigences du mot de passe",
        rules: {
          length: "Au moins 8 caractères",
          uppercase: "Au moins une lettre majuscule (A–Z)",
          lowercase: "Au moins une lettre minuscule (a–z)",
          number: "Au moins un chiffre (0–9)",
          special: "Au moins un caractère spécial (!@#$…)"
        },
        strength: {
          weak: "Faible",
          fair: "Moyen",
          good: "Bon",
          strong: "Fort"
        }
      },
      terms: {
        label: "J'ai lu et j'accepte les",
        link: "Conditions d'utilisation et politique de confidentialité",
        required: "Vous devez accepter les conditions générales pour vous inscrire"
      }
    }
  },
  nb: {
    title: "Registrer",
    subtitle: "Opprett din Qualitati-konto",
    auth: {
      actions: {
        register: "Registrer",
        signIn: "Logg inn",
        alreadyHaveAccount: "Har du allerede en konto?",
        resendVerification: "Send Bekreftelses-e-post På Nytt",
        resending: "Sender..."
      },
      fields: {
        username: "Brukernavn",
        email: "E-postadresse",
        password: "Passord",
        confirmPassword: "Bekreft passord",
        inviteCode: "Invitasjonskode",
        inviteCodeHelp: "Skriv inn invitasjonskoden du har fått fra organisasjonen din."
      },
      messages: {
        passwordMismatch: "Passordene stemmer ikke overens",
        checkEmail: "Vennligst sjekk e-posten din for å bekrefte kontoen din.",
        checkSpam: "Husk å sjekke spam-mappen din hvis du ikke ser e-posten.",
        verificationNote: "Merk: E-postbekreftelse er påkrevd for å aktivere kontoen din.",
        registrationSuccess: "Registrering vellykket! Vennligst sjekk e-posten din for å bekrefte kontoen din.",
        registrationFailed: "Registrering mislyktes. Vennligst prøv igjen.",
        emailSent: "Bekreftelses-e-post har blitt sendt til din e-postadresse.",
        redirecting: "Omdirigerer til innloggingssiden om 5 sekunder...",
        emailRequired: "E-post er påkrevd",
        emailInvalid: "Ugyldig e-postformat",
        passwordRequired: "Passord er påkrevd",
        usernameRequired: "Brukernavn er påkrevd",
        didNotReceiveEmail: "Fikk du ikke e-posten?",
        resendFailed: "Kunne ikke sende bekreftelses-e-post på nytt. Vennligst prøv igjen senere."
      },
      validation: {
        emailRequired: "E-post er påkrevd",
        emailInvalid: "Vennligst skriv inn en gyldig e-postadresse",
        passwordRequired: "Passord er påkrevd",
        passwordTooShort: "Passordet må være minst 6 tegn",
        passwordWeak: "Passordet oppfyller ikke sikkerhetskravene",
        usernameRequired: "Brukernavn er påkrevd",
        usernameTooShort: "Brukernavnet må være minst 3 tegn",
        confirmPasswordRequired: "Vennligst bekreft passordet ditt",
        inviteCodeRequired: "Invitasjonskode er påkrevd"
      },
      passwordPolicy: {
        title: "Passordkrav",
        rules: {
          length: "Minst 8 tegn",
          uppercase: "Minst én stor bokstav (A–Z)",
          lowercase: "Minst én liten bokstav (a–z)",
          number: "Minst ett tall (0–9)",
          special: "Minst ett spesialtegn (!@#$…)"
        },
        strength: {
          weak: "Svakt",
          fair: "Greit",
          good: "Bra",
          strong: "Sterkt"
        }
      },
      terms: {
        label: "Jeg har lest og godtar",
        link: "Vilkår for bruk og personvernpolicy",
        required: "Du må akseptere vilkårene og betingelsene for å registrere deg"
      }
    }
  },
  nl: {
    title: "Registreren",
    subtitle: "Maak uw Qualitati-account aan",
    auth: {
      actions: {
        register: "Registreren",
        signIn: "Inloggen",
        alreadyHaveAccount: "Heeft u al een account?",
        resendVerification: "Verificatie-e-mail Opnieuw Verzenden",
        resending: "Verzenden..."
      },
      fields: {
        username: "Gebruikersnaam",
        email: "E-mailadres",
        password: "Wachtwoord",
        confirmPassword: "Bevestig wachtwoord",
        inviteCode: "Uitnodigingscode",
        inviteCodeHelp: "Voer de uitnodigingscode in die u van uw organisatie heeft ontvangen."
      },
      messages: {
        passwordMismatch: "Wachtwoorden komen niet overeen",
        checkEmail: "Controleer uw e-mail om uw account te verifiëren.",
        checkSpam: "Vergeet niet uw spam-map te controleren als u de e-mail niet ziet.",
        verificationNote: "Opmerking: E-mailverificatie is vereist om uw account te activeren.",
        registrationSuccess: "Registratie succesvol! Controleer uw e-mail om uw account te verifiëren.",
        registrationFailed: "Registratie mislukt. Probeer het opnieuw.",
        emailSent: "Verificatie-e-mail is verzonden naar uw e-mailadres.",
        redirecting: "Doorverwijzen naar inlogpagina over 5 seconden...",
        emailRequired: "E-mail is vereist",
        emailInvalid: "Ongeldig e-mailformaat",
        passwordRequired: "Wachtwoord is vereist",
        usernameRequired: "Gebruikersnaam is vereist",
        didNotReceiveEmail: "E-mail niet ontvangen?",
        resendFailed: "Kan verificatie-e-mail niet opnieuw verzenden. Probeer het later opnieuw."
      },
      validation: {
        emailRequired: "E-mail is vereist",
        emailInvalid: "Voer een geldig e-mailadres in",
        passwordRequired: "Wachtwoord is vereist",
        passwordTooShort: "Wachtwoord moet minimaal 6 tekens lang zijn",
        passwordWeak: "Wachtwoord voldoet niet aan de beveiligingseisen",
        usernameRequired: "Gebruikersnaam is vereist",
        usernameTooShort: "Gebruikersnaam moet minimaal 3 tekens lang zijn",
        confirmPasswordRequired: "Bevestig uw wachtwoord",
        inviteCodeRequired: "Uitnodigingscode is vereist"
      },
      passwordPolicy: {
        title: "Wachtwoordvereisten",
        rules: {
          length: "Minimaal 8 tekens",
          uppercase: "Minimaal één hoofdletter (A–Z)",
          lowercase: "Minimaal één kleine letter (a–z)",
          number: "Minimaal één cijfer (0–9)",
          special: "Minimaal één speciaal teken (!@#$…)"
        },
        strength: {
          weak: "Zwak",
          fair: "Redelijk",
          good: "Goed",
          strong: "Sterk"
        }
      },
      terms: {
        label: "Ik heb gelezen en ga akkoord met de",
        link: "Servicevoorwaarden en Privacybeleid",
        required: "U moet de algemene voorwaarden accepteren om u te registreren"
      }
    }
  },
  de: {
    title: "Registrieren",
    subtitle: "Erstellen Sie Ihr Qualitati-Konto",
    auth: {
      actions: {
        register: "Registrieren",
        signIn: "Anmelden",
        alreadyHaveAccount: "Haben Sie bereits ein Konto?",
        resendVerification: "Bestätigungs-E-Mail Erneut Senden",
        resending: "Wird gesendet..."
      },
      fields: {
        username: "Benutzername",
        email: "E-Mail-Adresse",
        password: "Passwort",
        confirmPassword: "Passwort bestätigen",
        inviteCode: "Einladungscode",
        inviteCodeHelp: "Geben Sie den Einladungscode ein, den Sie von Ihrer Organisation erhalten haben."
      },
      messages: {
        passwordMismatch: "Passwörter stimmen nicht überein",
        checkEmail: "Bitte überprüfen Sie Ihre E-Mail, um Ihr Konto zu verifizieren.",
        checkSpam: "Vergessen Sie nicht, Ihren Spam-Ordner zu überprüfen, wenn Sie die E-Mail nicht sehen.",
        verificationNote: "Hinweis: E-Mail-Verifizierung ist erforderlich, um Ihr Konto zu aktivieren.",
        registrationSuccess: "Registrierung erfolgreich! Bitte überprüfen Sie Ihre E-Mail, um Ihr Konto zu verifizieren.",
        registrationFailed: "Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
        emailSent: "Bestätigungs-E-Mail wurde an Ihre E-Mail-Adresse gesendet.",
        redirecting: "Weiterleitung zur Anmeldeseite in 5 Sekunden...",
        emailRequired: "E-Mail ist erforderlich",
        emailInvalid: "Ungültiges E-Mail-Format",
        passwordRequired: "Passwort ist erforderlich",
        usernameRequired: "Benutzername ist erforderlich",
        didNotReceiveEmail: "E-Mail nicht erhalten?",
        resendFailed: "Fehler beim erneuten Senden der Bestätigungs-E-Mail. Bitte versuchen Sie es später erneut."
      },
      validation: {
        emailRequired: "E-Mail ist erforderlich",
        emailInvalid: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
        passwordRequired: "Passwort ist erforderlich",
        passwordTooShort: "Passwort muss mindestens 6 Zeichen haben",
        passwordWeak: "Das Passwort erfüllt die Sicherheitsanforderungen nicht",
        usernameRequired: "Benutzername ist erforderlich",
        usernameTooShort: "Benutzername muss mindestens 3 Zeichen haben",
        confirmPasswordRequired: "Bitte bestätigen Sie Ihr Passwort",
        inviteCodeRequired: "Einladungscode ist erforderlich"
      },
      passwordPolicy: {
        title: "Passwortanforderungen",
        rules: {
          length: "Mindestens 8 Zeichen",
          uppercase: "Mindestens ein Großbuchstabe (A–Z)",
          lowercase: "Mindestens ein Kleinbuchstabe (a–z)",
          number: "Mindestens eine Zahl (0–9)",
          special: "Mindestens ein Sonderzeichen (!@#$…)"
        },
        strength: {
          weak: "Schwach",
          fair: "Mittel",
          good: "Gut",
          strong: "Stark"
        }
      },
      terms: {
        label: "Ich habe gelesen und stimme den",
        link: "Nutzungsbedingungen und Datenschutzrichtlinien zu",
        required: "Sie müssen den Geschäftsbedingungen zustimmen, um sich zu registrieren"
      }
    }
  },
  es: {
    title: "Registrarse",
    subtitle: "Cree su cuenta Qualitati",
    auth: {
      actions: {
        register: "Registrarse",
        signIn: "Iniciar sesión",
        alreadyHaveAccount: "¿Ya tiene una cuenta?",
        resendVerification: "Reenviar Correo de Verificación",
        resending: "Enviando..."
      },
      fields: {
        username: "Nombre de usuario",
        email: "Dirección de correo electrónico",
        password: "Contraseña",
        confirmPassword: "Confirmar contraseña",
        inviteCode: "Código de invitación",
        inviteCodeHelp: "Ingrese el código de invitación proporcionado por su organización."
      },
      messages: {
        passwordMismatch: "Las contraseñas no coinciden",
        checkEmail: "Por favor, verifique su correo electrónico para verificar su cuenta.",
        checkSpam: "No olvide verificar su carpeta de spam si no ve el correo.",
        verificationNote: "Nota: La verificación por correo electrónico es requerida para activar su cuenta.",
        registrationSuccess: "¡Registro exitoso! Por favor, verifique su correo electrónico para verificar su cuenta.",
        registrationFailed: "Registro fallido. Por favor, intente de nuevo.",
        emailSent: "El correo de verificación ha sido enviado a su dirección de correo electrónico.",
        redirecting: "Redirigiendo a la página de inicio de sesión en 5 segundos...",
        emailRequired: "El correo electrónico es requerido",
        emailInvalid: "Formato de correo electrónico inválido",
        passwordRequired: "La contraseña es requerida",
        usernameRequired: "El nombre de usuario es requerido",
        didNotReceiveEmail: "¿No recibió el correo?",
        resendFailed: "Error al reenviar el correo de verificación. Por favor, inténtelo de nuevo más tarde."
      },
      validation: {
        emailRequired: "El correo electrónico es requerido",
        emailInvalid: "Por favor, ingrese una dirección de correo electrónico válida",
        passwordRequired: "La contraseña es requerida",
        passwordTooShort: "La contraseña debe tener al menos 6 caracteres",
        passwordWeak: "La contraseña no cumple los requisitos de seguridad",
        usernameRequired: "El nombre de usuario es requerido",
        usernameTooShort: "El nombre de usuario debe tener al menos 3 caracteres",
        confirmPasswordRequired: "Por favor, confirme su contraseña",
        inviteCodeRequired: "El código de invitación es requerido"
      },
      passwordPolicy: {
        title: "Requisitos de la contraseña",
        rules: {
          length: "Al menos 8 caracteres",
          uppercase: "Al menos una letra mayúscula (A–Z)",
          lowercase: "Al menos una letra minúscula (a–z)",
          number: "Al menos un número (0–9)",
          special: "Al menos un carácter especial (!@#$…)"
        },
        strength: {
          weak: "Débil",
          fair: "Aceptable",
          good: "Buena",
          strong: "Fuerte"
        }
      },
      terms: {
        label: "He leído y acepto los",
        link: "Términos de Servicio y Política de Privacidad",
        required: "Debe aceptar los términos y condiciones para registrarse"
      }
    }
  },
  pt: {
    title: "Registrar",
    subtitle: "Crie sua conta Qualitati",
    auth: {
      actions: {
        register: "Registrar",
        signIn: "Entrar",
        alreadyHaveAccount: "Já tem uma conta?",
        resendVerification: "Reenviar E-mail de Verificação",
        resending: "Enviando..."
      },
      fields: {
        username: "Nome de usuário",
        email: "Endereço de e-mail",
        password: "Senha",
        confirmPassword: "Confirmar senha",
        inviteCode: "Código de convite",
        inviteCodeHelp: "Insira o código de convite fornecido pela sua organização."
      },
      messages: {
        passwordMismatch: "As senhas não coincidem",
        checkEmail: "Por favor, verifique seu e-mail para confirmar sua conta.",
        checkSpam: "Não se esqueça de verificar sua pasta de spam se não encontrar o e-mail.",
        verificationNote: "Nota: A verificação por e-mail é necessária para ativar sua conta.",
        registrationSuccess: "Registro bem-sucedido! Por favor, verifique seu e-mail para confirmar sua conta.",
        registrationFailed: "Falha no registro. Por favor, tente novamente.",
        emailSent: "O e-mail de verificação foi enviado para o seu endereço de e-mail.",
        redirecting: "Redirecionando para a página de login em 5 segundos...",
        emailRequired: "O e-mail é obrigatório",
        emailInvalid: "Formato de e-mail inválido",
        passwordRequired: "A senha é obrigatória",
        usernameRequired: "O nome de usuário é obrigatório",
        didNotReceiveEmail: "Não recebeu o e-mail?",
        resendFailed: "Falha ao reenviar o e-mail de verificação. Por favor, tente novamente mais tarde."
      },
      validation: {
        emailRequired: "O e-mail é obrigatório",
        emailInvalid: "Por favor, insira um endereço de e-mail válido",
        passwordRequired: "A senha é obrigatória",
        passwordTooShort: "A senha deve ter pelo menos 6 caracteres",
        passwordWeak: "A senha não atende aos requisitos de segurança",
        usernameRequired: "O nome de usuário é obrigatório",
        usernameTooShort: "O nome de usuário deve ter pelo menos 3 caracteres",
        confirmPasswordRequired: "Por favor, confirme sua senha",
        inviteCodeRequired: "O código de convite é obrigatório"
      },
      passwordPolicy: {
        title: "Requisitos da senha",
        rules: {
          length: "Pelo menos 8 caracteres",
          uppercase: "Pelo menos uma letra maiúscula (A–Z)",
          lowercase: "Pelo menos uma letra minúscula (a–z)",
          number: "Pelo menos um número (0–9)",
          special: "Pelo menos um caractere especial (!@#$…)"
        },
        strength: {
          weak: "Fraca",
          fair: "Razoável",
          good: "Boa",
          strong: "Forte"
        }
      },
      terms: {
        label: "Li e concordo com os",
        link: "Termos de Serviço e Política de Privacidade",
        required: "Você deve aceitar os termos e condições para se registrar"
      }
    }
  },
  ja: {
    title: "登録",
    subtitle: "Qualitatiアカウントを作成",
    auth: {
      actions: {
        register: "登録",
        signIn: "ログイン",
        alreadyHaveAccount: "すでにアカウントをお持ちですか？",
        resendVerification: "確認メールを再送信",
        resending: "送信中..."
      },
      fields: {
        username: "ユーザー名",
        email: "メールアドレス",
        password: "パスワード",
        confirmPassword: "パスワードを確認",
        inviteCode: "招待コード",
        inviteCodeHelp: "所属組織から提供された招待コードを入力してください。"
      },
      messages: {
        passwordMismatch: "パスワードが一致しません",
        checkEmail: "アカウントを確認するためにメールをご確認ください。",
        checkSpam: "メールが見つからない場合は、迷惑メールフォルダもご確認ください。",
        verificationNote: "注意：アカウントを有効化するにはメール認証が必要です。",
        registrationSuccess: "登録が完了しました！アカウントを確認するためにメールをご確認ください。",
        registrationFailed: "登録に失敗しました。もう一度お試しください。",
        emailSent: "確認メールをお客様のメールアドレスに送信しました。",
        redirecting: "5秒後にログインページにリダイレクトします...",
        emailRequired: "メールアドレスは必須です",
        emailInvalid: "無効なメール形式",
        passwordRequired: "パスワードは必須です",
        usernameRequired: "ユーザー名は必須です",
        didNotReceiveEmail: "メールを受け取っていませんか？",
        resendFailed: "確認メールの再送信に失敗しました。後でもう一度お試しください。"
      },
      validation: {
        emailRequired: "メールアドレスは必須です",
        emailInvalid: "有効なメールアドレスを入力してください",
        passwordRequired: "パスワードは必須です",
        passwordTooShort: "パスワードは6文字以上でなければなりません",
        passwordWeak: "パスワードはセキュリティ要件を満たしていません",
        usernameRequired: "ユーザー名は必須です",
        usernameTooShort: "ユーザー名は3文字以上でなければなりません",
        confirmPasswordRequired: "パスワードを確認してください",
        inviteCodeRequired: "招待コードは必須です"
      },
      passwordPolicy: {
        title: "パスワード要件",
        rules: {
          length: "8 文字以上",
          uppercase: "大文字を 1 文字以上 (A–Z)",
          lowercase: "小文字を 1 文字以上 (a–z)",
          number: "数字を 1 文字以上 (0–9)",
          special: "記号を 1 文字以上 (!@#$…)"
        },
        strength: {
          weak: "弱い",
          fair: "普通",
          good: "良好",
          strong: "強い"
        }
      },
      terms: {
        label: "を読み、同意します",
        link: "利用規約とプライバシーポリシー",
        required: "登録するには利用規約に同意する必要があります"
      }
    }
  },
  ar: {
    title: "تسجيل",
    subtitle: "إنشاء حساب Qualitati الخاص بك",
    auth: {
      actions: {
        register: "تسجيل",
        signIn: "تسجيل الدخول",
        alreadyHaveAccount: "هل لديك حساب بالفعل؟",
        resendVerification: "إعادة إرسال بريد التحقق",
        resending: "جارٍ الإرسال..."
      },
      fields: {
        username: "اسم المستخدم",
        email: "عنوان البريد الإلكتروني",
        password: "كلمة المرور",
        confirmPassword: "تأكيد كلمة المرور",
        inviteCode: "رمز الدعوة",
        inviteCodeHelp: "أدخل رمز الدعوة المقدم من مؤسستك."
      },
      messages: {
        passwordMismatch: "كلمات المرور غير متطابقة",
        checkEmail: "يرجى التحقق من بريدك الإلكتروني لتأكيد حسابك.",
        checkSpam: "لا تنسَ التحقق من مجلد البريد العشوائي إذا لم تجد البريد الإلكتروني.",
        verificationNote: "ملاحظة: يلزم التحقق من البريد الإلكتروني لتفعيل حسابك.",
        registrationSuccess: "تم التسجيل بنجاح! يرجى التحقق من بريدك الإلكتروني لتأكيد حسابك.",
        registrationFailed: "فشل التسجيل. يرجى المحاولة مرة أخرى.",
        emailSent: "تم إرسال بريد التحقق إلى عنوان بريدك الإلكتروني.",
        redirecting: "جارٍ إعادة التوجيه إلى صفحة تسجيل الدخول خلال 5 ثوانٍ...",
        emailRequired: "البريد الإلكتروني مطلوب",
        emailInvalid: "تنسيق البريد الإلكتروني غير صالح",
        passwordRequired: "كلمة المرور مطلوبة",
        usernameRequired: "اسم المستخدم مطلوب",
        didNotReceiveEmail: "لم تستلم البريد الإلكتروني؟",
        resendFailed: "فشل إعادة إرسال بريد التحقق. يرجى المحاولة مرة أخرى لاحقاً."
      },
      validation: {
        emailRequired: "البريد الإلكتروني مطلوب",
        emailInvalid: "يرجى إدخال عنوان بريد إلكتروني صالح",
        passwordRequired: "كلمة المرور مطلوبة",
        passwordTooShort: "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل",
        passwordWeak: "كلمة المرور لا تستوفي متطلبات الأمان",
        usernameRequired: "اسم المستخدم مطلوب",
        usernameTooShort: "يجب أن يتكون اسم المستخدم من 3 أحرف على الأقل",
        confirmPasswordRequired: "يرجى تأكيد كلمة المرور",
        inviteCodeRequired: "رمز الدعوة مطلوب"
      },
      passwordPolicy: {
        title: "متطلبات كلمة المرور",
        rules: {
          length: "8 أحرف على الأقل",
          uppercase: "حرف كبير واحد على الأقل (A–Z)",
          lowercase: "حرف صغير واحد على الأقل (a–z)",
          number: "رقم واحد على الأقل (0–9)",
          special: "رمز خاص واحد على الأقل (!@#$…)"
        },
        strength: {
          weak: "ضعيفة",
          fair: "مقبولة",
          good: "جيدة",
          strong: "قوية"
        }
      },
      terms: {
        label: "لقد قرأت وأوافق على",
        link: "شروط الخدمة وسياسة الخصوصية",
        required: "يجب قبول الشروط والأحكام للتسجيل"
      }
    }
  }
};